import FieldDropdown from "../../../generic/dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import FieldCustomViewUserAccess_GListView from "./render/glist-view"
import FieldCustomViewUserAccess_GListEditable from "./render/glist-editable"

export default class FieldCustomViewUserAccess extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Crm Contact Type"

        this.options            = _.get(config, 'options', [
            {
                value   : 1,
                label   : 'Owner'
            },
            {
                value   : 0,
                label   : 'Shared'
            },
        ])

        // if true will add no value option to options list (by default true for custom fields)
        // this.noValueOption      = _.get(config,'addNoValueOption',true); // specified in FieldDropdown

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','Not specified');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        // this.icon = 'i5-crm-contact';
        //
        // this.isSearchable = true;
        //
        // this.components = _.assign({}, this.components, {
        //     PopoverMenuMore     : ContactTypePopoverMenuMore,
        //
        //     glistGroupStandard  : FieldContactType_GlistGroupStandard
        // })

        this.classes.PopoverMenu = 'max-w-250'
        this.classes.PopoverMenuScrollContainer = 'max-h-400'

        this.renderComponents.glistView     = FieldCustomViewUserAccess_GListView
        this.renderComponents.glistEditable = FieldCustomViewUserAccess_GListEditable
    }

    sortValue(value:any) {
        return _.get(this._getOption(value),'value', null);
    }

    // groupValue(value:any) {
    //     return _.get(this._getOption(value),'value', null);
    // }
    //
    // groupSortValue(value:any) {
    //     return _.indexOf(this.options, this._getOption(value));
    // }

}
